/**
 * ForgotPasswordModal — recuperacion aun no habilitada en el portal central.
 * Uses same Auth.css class names as the original LoginPage forgot-password modal.
 */
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import '../styles/LoginPortal.css';

const ForgotPasswordModal = ({ open, onClose }) => {
    useEffect(() => {
        if (!open) return undefined;
        const onKey = (e) => {
            if (e.key === 'Escape') onClose?.();
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [open, onClose]);

    if (!open) return null;

    return createPortal(
        <>
            <div
                className="auth-modal-backdrop"
                role="presentation"
                onClick={onClose}
            />
            <div
                className="auth-modal-panel"
                role="dialog"
                aria-modal="true"
                aria-labelledby="portal-forgot-title"
            >
                <div className="auth-modal-header">
                    <div className="auth-modal-title-block">
                        <h2 id="portal-forgot-title" className="auth-modal-title">
                            Recuperar contraseña
                        </h2>
                        <p className="auth-modal-subtitle">
                            La recuperación automática aún no está disponible en el LoginPortal.
                            Contactá a Soporte para restablecer el acceso.
                        </p>
                    </div>
                    <button
                        type="button"
                        className="auth-modal-close"
                        onClick={onClose}
                        aria-label="Cerrar"
                    >
                        <i className="bi bi-x-lg" />
                    </button>
                </div>
                <div className="auth-modal-footer">
                    <button
                        type="button"
                        className="auth-btn-primary"
                        onClick={onClose}
                    >
                        Entendido
                    </button>
                </div>
            </div>
        </>,
        document.body
    );
};

export default ForgotPasswordModal;
